
export const TRACKED_ENTRY_SOURCES = new Set( [ 'deck', 'email', 'deck-notification' ] );
export const ARCADE_PROJECT_STENCIL = 'arcades';
export const ROM_DESCRIPTION_KEY = 'rom.description';
export const ROM_NAME_KEY = 'rom.name';
export const ROOM_NAME_KEY = 'room.name';
export const KEY_MAP = {
            name: 'rom.name',
            description: 'rom.description',
            instructions: 'rom.instructions',
            bannerAlt: 'rom.banner.alt',
            alt: 'rom.alt',
        };
export const CRATE_PROJECT_NAME = [ 'arcade-ui', 'solution' ];        
export function transformBundle( data, locale = 'en-US' ) {
        const result = {};
      
        Object.entries( data?.stencils || {} ).forEach( ( [ romId, locales ] ) => {
            const romData = locales?.[ locale ] || Object.values( locales || {} )[ 0 ];
            if ( !romData ) {return;}
            Object.entries( KEY_MAP ).forEach( ( [ alias, key ] ) => {
                const value = romData[ key ];
                if ( value ) {
                    result[ `rom.${ romId }.${ alias }` ] = value;
                }
            } );
        } );
        return result;
    }